import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, object = authed
  const [viewRole, setViewRole] = useState(null); // CEO "view as" override

  const loadMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      setViewRole(data.role);
    } catch (e) {
      setUser(false);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    setViewRole(data.role);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    setUser(false);
    setViewRole(null);
  };

  const effectiveRole = user && user.role === "ceo" ? (viewRole || "ceo") : user?.role;

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, loadMe, viewRole, setViewRole, effectiveRole }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
